import React from 'react'

import { formatNotificationDate } from './notificationsApi'

const LABEL_MAP = {
  notificationId: 'ID',
  title: 'Título',
  body: 'Mensaje',
  url: 'Enlace',
  createdAt: 'Fecha',
  readAt: 'Leída',
}

export default function NotificationDetail({ notification }) {
  if (!notification) return null

  const entries = [
    ['title', notification.title],
    ['createdAt', formatNotificationDate(notification.createdAt)],
    ['body', notification.body],
  ]

  if (notification.url && notification.url !== '/') {
    entries.push(['url', notification.url])
  }

  return (
    <div className="notification-detail">
      {entries.map(([key, value]) => (
        <div key={key} className="notification-detail-row">
          <span className="notification-detail-label">{LABEL_MAP[key] || key}</span>
          <span className={`notification-detail-value${key === 'body' ? ' notification-detail-body' : ''}`}>
            {value}
          </span>
        </div>
      ))}
    </div>
  )
}
